import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=cf28ee82&scoped=true"
import script from "./CustomSwitch.vue?vue&type=script&lang=js"
export * from "./CustomSwitch.vue?vue&type=script&lang=js"
import style0 from "./CustomSwitch.vue?vue&type=style&index=0&id=cf28ee82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf28ee82",
  null
  
)

export default component.exports